<template>
    <div>
        <div class="fieldTable">
            <div :id="resultId"></div>
            <div class="fieldTable-single" v-for="(item, index) in tableTitleArr" :key="index"
                :style="{ height: index === 0 ? '180px' : '' }">
                <i class="el-icon-s-grid" style="padding-bottom:5px">{{ item }}</i>
                <template v-if="dataLoaded">
                    <div class="flex-table" :ref="`container${index}`" style="width: 800px;"></div>
                </template>
                <template v-else>
                    <el-skeleton :count="1" animated>
                        <template #template>
                            <el-skeleton-item variant="h1" style="width: 800px" />
                            <el-skeleton-item variant="rect" style="width: 800px; height: 145px;"></el-skeleton-item>
                        </template>
                    </el-skeleton>
                </template>
            </div>
        </div>
    </div>
</template>
  
<script>
import { TableSheet } from '@antv/s2';
import { getdatasbyid } from '../../api/unicomData'
export default {
    name: 'resourceDataTable',
    props: {
        resultId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            tableTitleArr: ['人口数量及基础属性', '上网标签分布', '手机品牌型号', '迁徙路径分析-职住职娱', '每小时段人口流量',
                '每日人流量及停留时长分布', '每月到达次数分布', 'APP 使用人数分布', '富裕指数', '人口教育水平', '人口行业', '人生阶段',
                '综合消费能力预测', '网购能力预测', '资产预测', '人群消费能力数据', '个性化标签', '市外来源分布', '职住热力',
                '迁徙路径分析-住娱住职', '迁徙路径分析-访住访职', '迁徙路径分析-娱住'],
            tableList: [],
            dataLoaded: false
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                const res = await this.initAPI();
                // this.dataLoaded = true;
                // const data = await res.data.result.data;
                setTimeout(() => {
                    this.dataLoaded = true;
                    this.renderTableSheet(res.data.result.data);
                }, 1000);
                //this.renderTableSheet(data);
            } catch (error) {
                console.error('Error data:', error);
            }
        },
        initAPI() {
            return getdatasbyid({ id: this.resultId })
        },
        renderTableSheet(data) {
            let totalData = JSON.parse(JSON.stringify(data))
            data = []
            data.push(totalData[1001])
            const s2DataConfig1 = {
                fields: {
                    columns: [{
                        key: 'peopleSummary',
                        children: ['p0_sum', 'p1_sum', 'p2_sum', 'p3_sum', 'p4_sum', 'pall_sum', 'p5_sum'],
                    },
                    {
                        key: 'genderStructure',
                        children: ['male1_sum', 'male2_sum', 'male0_sum', 'female1_sum', 'female2_sum', 'female0_sum'],
                    },
                    {
                        key: 'ageStructure',
                        children: ['age1_0006', 'age1_0612', 'age1_1215', 'age1_1518', 'age1_1924', 'age1_2529', 'age1_3034', 'age1_3539', 'age1_4044', 'age1_4549', 'age1_5054', 'age1_5559', 'age1_6064', 'age1_6569', 'age1_70up', 'age2_0006', 'age2_0612', 'age2_1215', 'age2_1518', 'age2_1924', 'age2_2529', 'age2_3034', 'age2_3539', 'age2_4044', 'age2_4549', 'age2_5054', 'age2_5559', 'age2_6064', 'age2_6569', 'age2_70up', 'age0_0006', 'age0_0612', 'age0_1215', 'age0_1518', 'age0_1924', 'age0_2529', 'age0_3034', 'age0_3539', 'age0_4044', 'age0_4549', 'age0_5054', 'age0_5559', 'age0_6064', 'age0_6569', 'age0_70up', 'arpu1_50', 'arpu1_100', 'arpu1_150', 'arpu1_200', 'arpu1_250', 'arpu1_up', 'arpu2_50', 'arpu2_100', 'arpu2_150', 'arpu2_200', 'arpu2_250', 'arpu2_up', 'arpu0_50', 'arpu0_100', 'arpu0_150', 'arpu0_200', 'arpu0_250', 'arpu0_up'],
                    }],
                },
                meta: [
                    { field: 'p0_sum', name: '到访人口数' },
                    { field: 'p1_sum', name: '居住人口数' },
                    { field: 'p2_sum', name: '工作人口数' },
                    { field: 'p3_sum', name: '外省到访人口数' },
                    { field: 'p4_sum', name: '娱乐人数' },
                    { field: 'pall_sum', name: '总人口规模' },
                    { field: 'p5_sum', name: '居住工作重合人数' },
                    { field: 'male1_sum', name: '居住男性数' },
                    { field: 'male2_sum', name: '工作男性数' },
                    { field: 'male0_sum', name: '到访男性数' },
                    { field: 'female1_sum', name: '居住女性数' },
                    { field: 'female2_sum', name: '工作女性数' },
                    { field: 'female0_sum', name: '到访女性数' },
                    { field: 'age1_0006', name: '居住人口 6 岁以下人数' },
                    { field: 'age1_0612', name: '居住人口 7-12 岁人数' },
                    { field: 'age1_1215', name: '居住人口 13-15 岁人数' },
                    { field: 'age1_1518', name: '居住人口 16-18 岁人数' },
                    { field: 'age1_1924', name: '居住人口 19-24 岁人数' },
                    { field: 'age1_2529', name: '居住人口 25-29 岁人数' },
                    { field: 'age1_3034', name: '居住人口 30-34 岁人数' },
                    { field: 'age1_3539', name: '居住人口 35-39 岁人数' },
                    { field: 'age1_4044', name: '居住人口 40-44 岁人数' },
                    { field: 'age1_4549', name: '居住人口 45-49 岁人数' },
                    { field: 'age1_5054', name: '居住人口 50-54 岁人数' },
                    { field: 'age1_5559', name: '居住人口 55-59 岁人数' },
                    { field: 'age1_6064', name: '居住人口 60-64 岁人数' },
                    { field: 'age1_6569', name: '居住人口 65-69 岁人数' },
                    { field: 'age1_70up', name: '居住人口 70 岁以上人数' },
                    { field: 'age2_0006', name: '工作人口 6 岁以下人数' },
                    { field: 'age2_0612', name: '工作人口 7-12 岁人数' },
                    { field: 'age2_1215', name: '工作人口 13-15 岁人数' },
                    { field: 'age2_1518', name: '工作人口 16-18 岁人数' },
                    { field: 'age2_1924', name: '工作人口 19-24 岁人数' },
                    { field: 'age2_2529', name: '工作人口 25-29 岁人数' },
                    { field: 'age2_3034', name: '工作人口 30-34 岁人数' },
                    { field: 'age2_3539', name: '工作人口 35-39 岁人数' },
                    { field: 'age2_4044', name: '工作人口 40-44 岁人数' },
                    { field: 'age2_4549', name: '工作人口 45-49 岁人数' },
                    { field: 'age2_5054', name: '工作人口 50-54 岁人数' },
                    { field: 'age2_5559', name: '工作人口 55-59 岁人数' },
                    { field: 'age2_6064', name: '工作人口 60-64 岁人数' },
                    { field: 'age2_6569', name: '工作人口 65-69 岁人数' },
                    { field: 'age2_70up', name: '工作人口 70 岁以上人数' },
                    { field: 'age0_0006', name: '到访人口 6 岁以下人数' },
                    { field: 'age0_0612', name: '到访人口 7-12 岁人数' },
                    { field: 'age0_1215', name: '到访人口 13-15 岁人数' },
                    { field: 'age0_1518', name: '到访人口 16-18 岁人数' },
                    { field: 'age0_1924', name: '到访人口 19-24 岁人数' },
                    { field: 'age0_2529', name: '到访人口 25-29 岁人数' },
                    { field: 'age0_3034', name: '到访人口 30-34 岁人数' },
                    { field: 'age0_3539', name: '到访人口 35-39 岁人数' },
                    { field: 'age0_4044', name: '到访人口 40-44 岁人数' },
                    { field: 'age0_4549', name: '到访人口 45-49 岁人数' },
                    { field: 'age0_5054', name: '到访人口 50-54 岁人数' },
                    { field: 'age0_5559', name: '到访人口 55-59 岁人数' },
                    { field: 'age0_6064', name: '到访人口 60-64 岁人数' },
                    { field: 'age0_6569', name: '到访人口 65-69 岁人数' },
                    { field: 'age0_70up', name: '到访人口 70 岁以上人数' },
                    { field: 'arpu1_50', name: '居住人口月出帐金额 50 元以下人数' },
                    { field: 'arpu1_100', name: '居住人口月出帐金额 50-100 元人数' },
                    { field: 'arpu1_150', name: '居住人口月出帐金额 100-150 元人数' },
                    { field: 'arpu1_200', name: '居住人口月出帐金额 150-200 元人数' },
                    { field: 'arpu1_250', name: '居住人口月出帐金额 200-250 元人数' },
                    { field: 'arpu1_up', name: '居住人口月出帐金额 250 元以上人数' },
                    { field: 'arpu2_50', name: '工作人口月出帐金额 50 元以下人数' },
                    { field: 'arpu2_100', name: '工作人口月出帐金额 50-100 元人数' },
                    { field: 'arpu2_150', name: '工作人口月出帐金额 100-150 元人数' },
                    { field: 'arpu2_200', name: '工作人口月出帐金额 150-200 元人数' },
                    { field: 'arpu2_250', name: '工作人口月出帐金额 200-250 元人数' },
                    { field: 'arpu2_up', name: '工作人口月出帐金额 250 元以上人数' },
                    { field: 'arpu0_50', name: '到访人口月出帐金额 50 元以下人数' },
                    { field: 'arpu0_100', name: '到访人口月出帐金额 50-100 元人数' },
                    { field: 'arpu0_150', name: '到访人口月出帐金额 100-150 元人数' },
                    { field: 'arpu0_200', name: '到访人口月出帐金额 150-200 元人数' },
                    { field: 'arpu0_250', name: '到访人口月出帐金额 200-250 元人数' },
                    { field: 'arpu0_up', name: '到访人口月出帐金额 250 元以上人数' },
                    { field: 'peopleSummary', name: '人口汇总' },
                    { field: 'genderStructure', name: '性别结构' },
                    { field: 'ageStructure', name: '年龄结构' }
                ],
                data,
            };
            data = totalData[1002]
            const popu_typeConfig2 = {
                '0': '到访',
                '1': '居住',
                '2': '工作',
            };
            const s2DataConfig2 = {
                fields: {
                    columns: ['popu_type', 'tag_name', 'tag_value'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'tag_name',
                        name: '网络标签名称',
                    },
                    {
                        field: 'tag_value',
                        name: '网络标签对应的人数',
                    }
                ],
                data,
            };
            data = totalData[1003]
            const s2DataConfig3 = {
                fields: {
                    columns: ['popu_type', 'phone_brand', 'phone_model', 'phone_value'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'phone_brand',
                        name: '手机品牌',
                    },
                    {
                        field: 'phone_model',
                        name: '手机型号',
                    },
                    {
                        field: 'phone_value',
                        name: '该品牌型号手机对应的人数',
                    }
                ],
                data,
            };
            data = totalData[1004]
            const popu_typeConfig4 = {
                '0': '职住矩阵',
                '1': '职娱矩阵'
            };
            const s2DataConfig4 = {
                fields: {
                    columns: ['od_type', 'co_fnid', 'popu_value'],
                },
                meta: [
                    {
                        field: 'od_type',
                        name: '迁徙类型',
                        formatter: (value) => popu_typeConfig4[value.toString()] || value
                    },
                    {
                        field: 'co_fnid',
                        name: '关联网格编号',
                    },
                    {
                        field: 'popu_value',
                        name: '人数',
                    }
                ],
                data,
            };
            data = totalData[1005]
            const popu_typeConfig5 = {
                '0': '工作日',
                '1': '周末'
            };
            const s2DataConfig5 = {
                fields: {
                    columns: ['hour_period', 'day_type', 'hour_all', 'hour_visit'],
                },
                meta: [
                    {
                        field: 'hour_period',
                        name: '小时时段'
                    },
                    {
                        field: 'day_type',
                        name: '日期类型',
                        formatter: (value) => popu_typeConfig5[value.toString()] || value
                    },
                    {
                        field: 'hour_all',
                        name: '小时全量人次',
                    },
                    {
                        field: 'hour_visit',
                        name: '小时到访人次',
                    }
                ],
                data,
            };
            data = totalData[1006]
            const s2DataConfig6 = {
                fields: {
                    columns: ['date', 'day_visit', 'day_all', 'stay1', 'stay2', 'stay3', 'stay4', 'stay5'],
                },
                meta: [
                    {
                        field: 'date',
                        name: '日期'
                    },
                    {
                        field: 'day_visit',
                        name: '每日到访人次'
                    },
                    {
                        field: 'day_all',
                        name: '每日出现总人次',
                    },
                    {
                        field: 'stay1',
                        name: '驻留小于 1 小时人次',
                    },
                    {
                        field: 'stay2',
                        name: '驻留 1-3 小时人次',
                    },
                    {
                        field: 'stay3',
                        name: '驻留 3-6 小时人次',
                    },
                    {
                        field: 'stay4',
                        name: '驻留 6-9 小时人次',
                    },
                    {
                        field: 'stay5',
                        name: '驻留大于 9 小时人次',
                    }
                ],
                data,
            };
            data = totalData[1007]
            const s2DataConfig7 = {
                fields: {
                    columns: ['reach1', 'reach2', 'reach3', 'reach4', 'reach5'],
                },
                meta: [
                    {
                        field: 'reach1',
                        name: '月驻留次数为 1 次的人数'
                    },
                    {
                        field: 'reach2',
                        name: '月驻留次数为 2-4 次的人数'
                    },
                    {
                        field: 'reach3',
                        name: '月驻留次数为 5-10 次的人数',
                    },
                    {
                        field: 'reach4',
                        name: '月驻留次数为 11-20 次的人数',
                    },
                    {
                        field: 'reach5',
                        name: '月驻留次数 20 次以上的人数',
                    }
                ],
                data,
            };
            data = totalData[1008]
            const s2DataConfig8 = {
                fields: {
                    columns: ['popu_type', 'app_level1', 'app_level2', 'appname', 'popu_value'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'app_level1',
                        name: 'APP 一级分类'
                    },
                    {
                        field: 'app_level2',
                        name: 'APP 二级分类',
                    },
                    {
                        field: 'appname',
                        name: 'APP 名称',
                    },
                    {
                        field: 'popu_value',
                        name: '使用该 APP 人数',
                    }
                ],
                data,
            };
            data = totalData[1009]
            const s2DataConfig9 = {
                fields: {
                    columns: ['popu_type', 'spendpower', 'spendpower_value'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'spendpower',
                        name: '消费能力指数(1-8级)'
                    },
                    {
                        field: 'spendpower_value',
                        name: '消费能力区间对应的人数',
                    }
                ],
                data,
            };
            data = totalData[1010]
            const s2DataConfig10 = {
                fields: {
                    columns: ['popu_type', 'fname', 'p0', 'p1', 'p2', 'p3', 'p4'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'fname',
                        name: '标签名称'
                    },
                    {
                        field: 'p0',
                        name: '高中及以下人数',
                    },
                    {
                        field: 'p1',
                        name: '大专人数',
                    },
                    {
                        field: 'p2',
                        name: '本科人数',
                    },
                    {
                        field: 'p3',
                        name: '硕士人数',
                    },
                    {
                        field: 'p4',
                        name: '博士人数',
                    }
                ],
                data,
            };
            data = totalData[1011]
            const s2DataConfig11 = {
                fields: {
                    columns: ['popu_type', 'fname', 'p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7', 'p8', 'p9', 'p10'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'fname',
                        name: '标签名称'
                    },
                    {
                        field: 'p1',
                        name: '金融从业者',
                    },
                    {
                        field: 'p2',
                        name: '医务人员',
                    },
                    {
                        field: 'p3',
                        name: '公务员&事业单位',
                    },
                    {
                        field: 'p4',
                        name: '白领及一般职员',
                    },
                    {
                        field: 'p5',
                        name: '工人及服务业人员',
                    },
                    {
                        field: 'p6',
                        name: '教师',
                    },
                    {
                        field: 'p7',
                        name: '农民及其他',
                    },
                    {
                        field: 'p8',
                        name: '网约车司机',
                    },
                    {
                        field: 'p9',
                        name: '外卖员',
                    },
                    {
                        field: 'p10',
                        name: '快递员',
                    }
                ],
                data,
            };
            data = totalData[1012]
            const s2DataConfig12 = {
                fields: {
                    columns: ['popu_type', 'fname', 'p1', 'p2', 'p3'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'fname',
                        name: '标签名称'
                    },
                    {
                        field: 'p1',
                        name: '已婚已育',
                    },
                    {
                        field: 'p2',
                        name: '已婚未育',
                    },
                    {
                        field: 'p3',
                        name: '未婚未育',
                    }
                ],
                data,
            };
            data = totalData[1013]
            const s2DataConfig13 = {
                fields: {
                    columns: ['popu_type', 'fname', 'p1', 'p2', 'p3'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'fname',
                        name: '标签名称'
                    },
                    {
                        field: 'p1',
                        name: '高人数',
                    },
                    {
                        field: 'p2',
                        name: '中人数',
                    },
                    {
                        field: 'p3',
                        name: '低人数',
                    }
                ],
                data,
            };
            data = totalData[1014]
            const s2DataConfig14 = {
                fields: {
                    columns: ['popu_type', 'fname', 'p1', 'p2', 'p3', 'p4', 'p5'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'fname',
                        name: '标签名称'
                    },
                    {
                        field: 'p1',
                        name: '高人数',
                    },
                    {
                        field: 'p2',
                        name: '中高人数',
                    },
                    {
                        field: 'p3',
                        name: '中人数',
                    },
                    {
                        field: 'p4',
                        name: '中低人数',
                    },
                    {
                        field: 'p5',
                        name: '低人数',
                    }
                ],
                data,
            };
            data = totalData[1015]
            const s2DataConfig15 = {
                fields: {
                    columns: ['popu_type', 'fname', 'p1', 'p2', 'p3', 'p4', 'p5'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'fname',
                        name: '标签名称'
                    },
                    {
                        field: 'p1',
                        name: '高人数',
                    },
                    {
                        field: 'p2',
                        name: '中高人数',
                    },
                    {
                        field: 'p3',
                        name: '中人数',
                    },
                    {
                        field: 'p4',
                        name: '中低人数',
                    },
                    {
                        field: 'p5',
                        name: '低人数',
                    }
                ],
                data,
            };
            data = totalData[1016]
            const s2DataConfig16 = {
                fields: {
                    columns: ['popu_type', 'fname', 'p1', 'p2', 'p3', 'p4', 'p5'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'fname',
                        name: '标签名称（兴趣偏好类型）'
                    },
                    {
                        field: 'p1',
                        name: '高人数',
                    },
                    {
                        field: 'p2',
                        name: '中高人数',
                    },
                    {
                        field: 'p3',
                        name: '中人数',
                    },
                    {
                        field: 'p4',
                        name: '中低人数',
                    },
                    {
                        field: 'p5',
                        name: '低人数',
                    }
                ],
                data,
            };
            data = totalData[1017]
            const s2DataConfig17 = {
                fields: {
                    columns: ['popu_type', 'ss0002_0', 'ss0002_1', 'ss0003_0', 'ss0003_1', 'ss0003_2', 'ss0007_0', 'ss0007_1', 'ss0043_0', 'ss0043_1', 'ss0045_0', 'ss0045_1', 'ss0045_2', 'ss0045_3', 'ss0045_4', 'ss0045_5', 'ss0047_0', 'ss0047_1', 'ss0047_2', 'ss0047_3', 'ss0047_4', 'ss0047_5', 'ss0050_0', 'ss0050_1', 'ss0051_0', 'ss0051_1', 'ss0052_0', 'ss0052_1', 'ss0053_0', 'ss0053_1', 'ss0054_0', 'ss0054_1', 'ss0055_0', 'ss0055_1', 'ss0057_0', 'ss0057_1'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'ss0002_0',
                        name: '非孕产人群'
                    },
                    {
                        field: 'ss0002_1',
                        name: '新手妈咪',
                    },
                    {
                        field: 'ss0003_0',
                        name: '非在校生',
                    },
                    {
                        field: 'ss0003_1',
                        name: '在校本专科',
                    },
                    {
                        field: 'ss0003_2',
                        name: '在校硕博生',
                    },
                    {
                        field: 'ss0007_0',
                        name: '非成功人士',
                    },
                    {
                        field: 'ss0007_1',
                        name: '成功人士',
                    },
                    {
                        field: 'ss0043_0',
                        name: '非提升党',
                    },
                    {
                        field: 'ss0043_1',
                        name: '提升党',
                    },
                    {
                        field: 'ss0045_0',
                        name: '工作稳定性-其他',
                    },
                    {
                        field: 'ss0045_1',
                        name: '工作稳定性-低',
                    },
                    {
                        field: 'ss0045_2',
                        name: '工作稳定性-中低',
                    },
                    {
                        field: 'ss0045_3',
                        name: '工作稳定性-中',
                    },
                    {
                        field: 'ss0045_4',
                        name: '工作稳定性-中高',
                    },
                    {
                        field: 'ss0045_5',
                        name: '工作稳定性-高',
                    },
                    {
                        field: 'ss0047_0',
                        name: '居住稳定性-其他',
                    },
                    {
                        field: 'ss0047_1',
                        name: '居住稳定性-低',
                    },
                    {
                        field: 'ss0047_2',
                        name: '居住稳定性-中低',
                    },
                    {
                        field: 'ss0047_3',
                        name: '居住稳定性-中',
                    },
                    {
                        field: 'ss0047_4',
                        name: '居住稳定性-中高',
                    },
                    {
                        field: 'ss0047_5',
                        name: '居住稳定性-高',
                    },
                    {
                        field: 'ss0050_0',
                        name: '非 Gen Z 人群',
                    },
                    {
                        field: 'ss0050_1',
                        name: 'Gen Z 人群',
                    },
                    {
                        field: 'ss0051_0',
                        name: '非小镇中老年',
                    },
                    {
                        field: 'ss0051_1',
                        name: '小镇中老年',
                    },
                    {
                        field: 'ss0052_0',
                        name: '非新锐白领',
                    },
                    {
                        field: 'ss0052_1',
                        name: '新锐白领',
                    },
                    {
                        field: 'ss0053_0',
                        name: '非资深中产',
                    },
                    {
                        field: 'ss0053_1',
                        name: '资深中产',
                    },
                    {
                        field: 'ss0054_0',
                        name: '非都市蓝领',
                    },
                    {
                        field: 'ss0054_1',
                        name: '都市蓝领',
                    },
                    {
                        field: 'ss0055_0',
                        name: '非都市银发',
                    },
                    {
                        field: 'ss0055_1',
                        name: '都市银发',
                    },
                    {
                        field: 'ss0057_0',
                        name: '非家有儿女',
                    },
                    {
                        field: 'ss0057_1',
                        name: '家有儿女',
                    }
                ],
                data,
            };
            //地产标签-暂时没数据，不做渲染
            data = totalData[1018]
            const group_typeConfig18 = {
                '12': '白+黑通勤人口',
                '13': '5+2 通勤人口',
                '3': '差旅人口',
                '4': '土著人口',
            };
            const popu_typeConfig18 = {
                '1': '居住',
                '2': '工作'
            };
            const s2DataConfig18 = {
                fields: {
                    columns: ['group_type', 'popu_type', 'popu_value'],
                },
                meta: [
                    {
                        field: 'group_type',
                        name: '人群类型',
                        formatter: (value) => group_typeConfig18[value.toString()] || value
                    },
                    {
                        field: 'popu_type',
                        name: '驻留类型',
                        formatter: (value) => popu_typeConfig18[value.toString()] || value
                    },
                    {
                        field: 'popu_value',
                        name: '人数'
                    }
                ],
                data,
            };
            data = totalData[1019]
            const s2DataConfig19 = {
                fields: {
                    columns: ['popu_type', 'co_province', 'co_city', 'popu_value'],
                },
                meta: [
                    {
                        field: 'popu_type',
                        name: '人群类型',
                        formatter: (value) => popu_typeConfig2[value.toString()] || value
                    },
                    {
                        field: 'co_province',
                        name: '来源省'
                    },
                    {
                        field: 'co_city',
                        name: '来源市'
                    },
                    {
                        field: 'popu_value',
                        name: '该省市对应的人数'
                    }
                ],
                data,
            };
            data = totalData[1020]
            const s2DataConfig20 = {
                fields: {
                    columns: ['fnid', 'p1_sum', 'p2_sum'],
                },
                meta: [
                    {
                        field: 'fnid',
                        name: '网格编号（geohash7）'
                    },
                    {
                        field: 'p1_sum',
                        name: '居住人口数'
                    },
                    {
                        field: 'p2_sum',
                        name: '工作人口数'
                    }
                ],
                data,
            };
            data = totalData[1021]
            const od_typeConfig21 = {
                '2': '住娱矩阵',
                '5': '住职矩阵'
            };
            const s2DataConfig21 = {
                fields: {
                    columns: ['od_type', 'co_fnid', 'popu_value'],
                },
                meta: [
                    {
                        field: 'od_type',
                        name: '迁徙类型',
                        formatter: (value) => od_typeConfig21[value.toString()] || value
                    },
                    {
                        field: 'co_fnid',
                        name: '关联网格编号'
                    },
                    {
                        field: 'popu_value',
                        name: '人数'
                    }
                ],
                data,
            };
            data = totalData[1022]
            const od_typeConfig22 = {
                '10': '访住矩阵',
                '20': '访职矩阵'
            };
            const s2DataConfig22 = {
                fields: {
                    columns: ['od_type', 'co_fnid', 'popu_value'],
                },
                meta: [
                    {
                        field: 'od_type',
                        name: '迁徙类型',
                        formatter: (value) => od_typeConfig22[value.toString()] || value
                    },
                    {
                        field: 'co_fnid',
                        name: '关联网格编号'
                    },
                    {
                        field: 'popu_value',
                        name: '人数'
                    }
                ],
                data,
            };
            data = totalData[1023]
            const od_typeConfig23 = {
                '4': '娱住矩阵'
            };
            const s2DataConfig23 = {
                fields: {
                    columns: ['od_type', 'co_fnid', 'popu_value'],
                },
                meta: [
                    {
                        field: 'od_type',
                        name: '迁徙类型',
                        formatter: (value) => od_typeConfig23[value.toString()] || value
                    },
                    {
                        field: 'co_fnid',
                        name: '关联网格编号'
                    },
                    {
                        field: 'popu_value',
                        name: '人数'
                    }
                ],
                data,
            };
            let s2DataConfigArr = []
            s2DataConfigArr.push(s2DataConfig1, s2DataConfig2, s2DataConfig3, s2DataConfig4, s2DataConfig5, s2DataConfig6, s2DataConfig7, s2DataConfig8, s2DataConfig9, s2DataConfig10, s2DataConfig11, s2DataConfig12, s2DataConfig13, s2DataConfig14, s2DataConfig15, s2DataConfig16, s2DataConfig17, s2DataConfig19, s2DataConfig20, s2DataConfig21, s2DataConfig22, s2DataConfig23)

            const s2Options = {
                width: 800,
                height: 480,
                showSeriesNumber: false,
                style: {
                    layoutWidthType: 'adaptive',
                    cellCfg: {
                        height: 50
                    },
                    colCfg: {
                        height: 50,
                        width: (colNode) => {
                            if (colNode.value.length > 10 && colNode.value != '网格编号（geohash7）' && colNode.value != '消费能力区间对应的人数' && colNode.value != '消费能力指数(1-8级)') {
                                return 220
                            }
                        }
                    }
                },
            };
            for (let i = 0; i < this.tableTitleArr.length; i++) {
                this.$nextTick(() => {
                    if (s2DataConfigArr[i].data.length > 11) {
                        s2Options.height = 500
                    }
                    else if (s2DataConfigArr[i].data.length <= 3) {
                        s2Options.height = 200
                    }
                    const container = this.$refs[`container${i}`][0];
                    if (container) {
                        const tableSheet = new TableSheet(container, s2DataConfigArr[i], s2Options);
                        tableSheet.setThemeCfg({ name: 'colorful' });
                        tableSheet.setTheme({
                            dataCell: {
                                text: {
                                    textAlign: 'center',
                                    textBaseline: 'middle',
                                }
                            }
                        });
                        tableSheet.render();
                    }
                });
            }
        }
    },
};
</script>
<style  scoped>
.fieldTable {
    display: flex;
    flex-direction: column;
}

.fieldTable-single {
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/unicomData/resourceTable.vue